<template>
    <div v-if="anchorEle" ref="container" :style="style">
        <slot></slot>
    </div>
</template>

<script>
export default {
    props: {
        scrollElementClass: { type: String, default: 'page-content'},
        anchorEle: {type: HTMLDivElement},
        height: { type: Number, default: 250},
        align: { type: String, default: 'right'} // 'right' or 'left'
    },
    mounted() {
        document.getElementsByClassName(this.scrollElementClass)[0]?.addEventListener('scroll', this.onScroll);
    },
    beforeDestroy() {
        document.getElementsByClassName(this.scrollElementClass)[0]?.removeEventListener('scroll', this.onScroll);
    },
    methods: {
        onScroll() {
            console.log(1);
            this.$forceUpdate();
        }
    },
    computed: {
		style() {
            if (!this.anchorEle.offsetParent) {
                return {opacity: 0};
            }
			let container = this.$refs['container'];
            let containerHeight = this.height;
            
			var style = {
                display: 'block',
				position: 'fixed'
            };
            
            if (this.align == 'right') {
				style.right = (window.innerWidth - (this.anchorEle.getBoundingClientRect().left + $(this.anchorEle).width())) + 'px';
            } else {
				style.left = (this.anchorEle.offsetParent.offsetLeft + this.anchorEle.offsetLeft) + 'px';
            }

			let containerAnchorY = this.anchorEle.getBoundingClientRect().y;
			var bottomYOfcontainer = containerAnchorY + this.anchorEle.offsetHeight + 10 + containerHeight;
			if (bottomYOfcontainer > window.innerHeight) {
				style.bottom = (window.innerHeight - containerAnchorY) - 10 + 'px';
			} else {
				style.top = containerAnchorY + this.anchorEle.offsetHeight + 10 + 'px';
			}
			return style;
        }
    }

}
</script>

<style>

</style>